import { formatEnumLabel } from "./formatEnumLabel";
export type Option = { value: string; label: string };

/**
 * Aceita:
 * - Record<string,string>           ex: { IMEDIATA: "IMEDIATA", TRINTA_DIAS: "30_DIAS" }
 * - readonly string[]               ex: ["IMEDIATA","30_DIAS"]
 * - readonly [string,string][]      ex: [["IMEDIATA","IMEDIATA"],["TRINTA_DIAS","30_DIAS"]]
 */
export function toOptions(
  source:
    | Record<string, string>
    | readonly string[]
    | readonly (readonly [string, string])[]
): Option[] {
  if (Array.isArray(source)) {
    if (source.length > 0 && Array.isArray(source[0])) {
      // array de tuplas [key,value]
      return (source as readonly (readonly [string, string])[]).map(
        ([k, v]) => ({
          value: String(v),
          label: formatEnumLabel(String(k)),
        })
      );
    }
    // array de strings
    return (source as readonly string[]).map((v) => ({
      value: String(v),
      label: formatEnumLabel(String(v)),
    }));
  }

  // objeto Record
  return Object.entries(source).map(([k, v]) => ({
    value: String(v),
    label: formatEnumLabel(String(k)),
  }));
}
